export default "__VITE_ASSET__DxQpJqlc__"